import React from 'react';
import { AppSetting } from 'dependencies/appsettings';
import { ButtonCallToAction } from 'ui';
import { externalRedirect } from 'app/infrastructure/platform';
import styles from './user-profile-heading.scss';

interface UserProfileHeadingProps {
  className?: string;
  title: string;
  showExternalUserHandlingLink?: boolean;
  externalUserHandlingLinkTitle?: string;
}

export const UserProfileHeading = ({
  className, title, showExternalUserHandlingLink, externalUserHandlingLinkTitle
}: UserProfileHeadingProps) => {

  const isExternalUserHandlingEnabled = (AppSetting.ExternalUserHandlingEnabled || {} as any);
  const viewUserLink = (AppSetting.ViewUserLink || {} as any);
  const redirectToExternalUserHandlingProfile = () => externalRedirect(viewUserLink, true);

  return (<>
    <div className={`${styles.headerWrapper} ${className} header-panel`}>
      <div className={`main-grid ${isExternalUserHandlingEnabled ? styles.flexContainer : ''}`}>
        <div className={styles.headerPanel}>
          <h2>{title}</h2>
        </div>
        {
          showExternalUserHandlingLink && isExternalUserHandlingEnabled && !!viewUserLink && <ButtonCallToAction
            id="external-user-handling-link"
            onClick={redirectToExternalUserHandlingProfile}
            disabled={false}>
            {externalUserHandlingLinkTitle}
          </ButtonCallToAction>
        }
      </div>
    </div>
  </>);
};
